module.exports = __webpack_public_path__ + "media/images/errors/422-91efbe78b2097ca182a73aec71649945.png";